enum CallbackTokenScopeEnum{
    Aisp = 'aisp',
    PaymentConfirmation = 'payment_confirmation'
}

export default CallbackTokenScopeEnum;

